import { Entities, Periods } from 'cio/utils/metrics/common';
import { TrackedResponseMetric } from 'cio/utils/metrics/models/tracked-response-metric';
import { TimeRange } from 'cio/utils/time';

export function deserialize(
  data: {
    tracked_response_metrics: Record<string, any> | null;
  },
  entityType: Entities,
  entityId: number | string,
  resolution: Periods | null,
  range: TimeRange | null,
): null | TrackedResponseMetric {
  let { tracked_response_metrics: trackedResponseMetrics } = data;

  if (!trackedResponseMetrics) {
    return null;
  }

  return new TrackedResponseMetric(entityId, entityType, resolution ?? Periods.DAYS, trackedResponseMetrics, range);
}
